import { createContext } from 'react';

import type { LocalisationHelpers } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

const LocalisationContext = createContext<Partial<LocalisationHelpers>>({});

export default LocalisationContext;
